import TEnvReader from 'tbase/readers/Env';
import apiService, { getDefaultHeader } from './apiService';
var BASE_URL = "".concat(TEnvReader.cmdsUrl(process.env), "api/");
var FILTER_BASE_URL = 'sales/settings/u/v1.0.0';
var GROUP_FILTER_BASE_URL = "".concat(FILTER_BASE_URL, "/groupFilter");
var DEFAULT_FILTER_BASE_URL = "".concat(FILTER_BASE_URL, "/listFilter");
var API_ROUTES = {
  fetchFilterGroupList: function fetchFilterGroupList(assetType) {
    return "/".concat(GROUP_FILTER_BASE_URL, "/").concat(assetType, "/filter/preference/list");
  },
  createFilterGroup: function createFilterGroup(assetType) {
    return "/".concat(GROUP_FILTER_BASE_URL, "/").concat(assetType, "/filter/preference/");
  },
  updateFilterGroup: function updateFilterGroup(assetType, groupId) {
    return "/".concat(GROUP_FILTER_BASE_URL, "/").concat(assetType, "/filter/preference/").concat(groupId);
  },
  fetchDefaultFilterValues: function fetchDefaultFilterValues(assetType) {
    return "/".concat(DEFAULT_FILTER_BASE_URL, "/").concat(assetType, "/filter/preference");
  },
  saveDefaultFilters: function saveDefaultFilters(assetType) {
    return "/".concat(DEFAULT_FILTER_BASE_URL, "/").concat(assetType, "/filter/preference");
  }
};
/**
 * groupFilter apis
 */

export var fetchFilterGroupList = function fetchFilterGroupList(assetType) {
  return apiService(BASE_URL, getDefaultHeader()).get(API_ROUTES.fetchFilterGroupList(assetType));
};
export var createFilterGroup = function createFilterGroup(assetType, payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_ROUTES.createFilterGroup(assetType), payload);
};
export var updateFilterGroup = function updateFilterGroup(assetType, groupId, payload) {
  return apiService(BASE_URL, getDefaultHeader()).put(API_ROUTES.updateFilterGroup(assetType, groupId), payload);
};
export var deleteFilterGroup = function deleteFilterGroup(assetType, groupId) {
  return apiService(BASE_URL, getDefaultHeader())["delete"](API_ROUTES.updateFilterGroup(assetType, groupId));
};
/**
 * listFilter apis
 */

export var fetchDefaultFilterValues = function fetchDefaultFilterValues(assetType) {
  return apiService(BASE_URL, getDefaultHeader()).get(API_ROUTES.fetchDefaultFilterValues(assetType));
};
export var saveDefaultFilters = function saveDefaultFilters(assetType, payload) {
  return apiService(BASE_URL, getDefaultHeader()).post(API_ROUTES.saveDefaultFilters(assetType), payload);
};